import { myAccountApi, type RatingPayload } from '@ctct/infrastructure-layer';

import { PlanGroupResponseSchema } from './schemas/plan-group.zod';
import { RatingResponseSchema } from './schemas/rating.zod';
import { Rating } from '../../value-objects';
import { PlanGroup } from '../../value-objects/plan-group';
import { zodService } from '../ZodService';

class PlanRepo {
  public async getPlanGroup(currency: string, count = 0, usage?: string, planGroupId?: number) {
    const response = await myAccountApi.getPlanGroup(currency, count, usage, planGroupId);

    const data = zodService.safeParse(PlanGroupResponseSchema, response.data);

    const PlanGroupVO = new PlanGroup(data);

    return PlanGroupVO;
  }

  public async getPlanRating(body: RatingPayload) {
    // TODO: this will be moved
    const postedPayload = {
      ...body,
      ...(body.stripeAccount
        ? {
            includeTax: true,
          }
        : null),
    };

    const response = await myAccountApi.postPlanRating(postedPayload);

    const data = zodService.safeParse(RatingResponseSchema, response.data);

    return new Rating(data);
  }
}

export const planRepo = new PlanRepo();
